import logo from '../../../assets/images/artwer/logo-white-text.png';
import { CloseIcon } from '../../artwer/icons';

const MobileNav = ({ handleMobileMenu }) => {
  return (
    <>
      <div className="mobile-nav__wrapper">
        <div
          className="mobile-nav__overlay mobile-nav__toggler"
          onClick={handleMobileMenu}
          aria-hidden="true"
        />
        <div className="mobile-nav__content">
          <button
            type="button"
            className="mobile-nav__close mobile-nav__toggler"
            onClick={handleMobileMenu}
            aria-label="Menu sluiten"
          >
            <CloseIcon />
          </button>
          <div className="logo-box">
            <a href="#home" aria-label="ART-WER" onClick={handleMobileMenu}>
              <img src={logo} width="150" alt="ART-WER" />
            </a>
          </div>
          <nav className="mobile-nav__container" aria-label="Mobiel menu">
            <ul className="main-menu__list">
              <li><a href="#home" onClick={handleMobileMenu}>Home</a></li>
              <li><a href="#diensten" onClick={handleMobileMenu}>Diensten</a></li>
              <li><a href="#over" onClick={handleMobileMenu}>Over ons</a></li>
              <li><a href="#werkwijze" onClick={handleMobileMenu}>Werkwijze</a></li>
              <li><a href="#projecten" onClick={handleMobileMenu}>Projecten</a></li>
              <li><a href="#contact" onClick={handleMobileMenu}>Contact</a></li>
            </ul>
          </nav>
          <div className="mobile-nav__contact-info" style={{ marginTop: '30px' }}>
            <a href="tel:+31616136942" style={{ display: 'block', color: '#fff', marginBottom: '10px' }}>
              <i className="icon-call" /> +31 6 16 13 69 42
            </a>
            <a href="mailto:info@art-wer.nl" style={{ display: 'block', color: '#fff' }}>
              <i className="icon-envelope" /> info@art-wer.nl
            </a>
          </div>
        </div>
      </div>
    </>
  );
};

export default MobileNav;
